/**
 * @fileoverview Public entry point to the auth session.
 * @description Thin wrapper over the auth store so route guards and feature code depend on
 * shared/lib/auth instead of importing the auth store directly.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { useAuthStore } from '@/shared/lib/auth/auth.store'

/**
 * @description Reads the current auth session and exposes its login/logout actions.
 * @returns {ReturnType<typeof useAuthStore>} The current user, token, isAuthenticated flag, and
 * the login/logout mutators.
 */
export function useAuth() {
  return useAuthStore((state) => state)
}
